import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

import { TableConfig } from '@app/shared/util/table-config.utils';

import { ToolLifecycleHistory } from '@models/tool-lifecycle-history.model';
import { TableColumnComponent } from '@components/custom-table/components/column/table-column.component';

@Component({
    selector: 'app-lifecycle-history-table',
    templateUrl: './lifecycle-history-table.component.html',
    styleUrls: ['./lifecycle-history-table.component.scss']
})
export class LifecycleHistoryTableComponent implements OnInit {

    @ViewChild('date', {static: true}) dateColumn: TableColumnComponent;
    @Input() toolLifecycleHistory: ToolLifecycleHistory[] = [];
    @Input() tableConfig: TableConfig;
    @Input() isLoading = false;
    @Input() headerBackgroundColor: string;
    @Input() hasTitle = true;

    @Output() pageChange = new EventEmitter<any>();
    @Output() filterChange = new EventEmitter<any>();
    @Output() sortChange = new EventEmitter<any>();
    @Output() selectTicket = new EventEmitter<number>();

    constructor() {
    }

    ngOnInit() {
        this.dateColumn.sort = {
            active: true,
            direction: 'desc'
        };
    }

    public openTicket(ticketId: number) {
        this.selectTicket.emit(ticketId);
    }

    onPageChange(tableConfig: TableConfig) {
        this.pageChange.emit(tableConfig);
    }

    onSortChange(tableConfig: TableConfig) {
        this.sortChange.emit(tableConfig);
    }

    onFilterChange(tableConfig: TableConfig) {
        this.filterChange.emit(tableConfig);
    }

}
